 //caseSuccess   //nomder
  const dataColumnMain = [
    {
      title: "ลำดับ",
      dataIndex: "keyA",
      key: "keyA",
      render: (text, record, index) => index + 1,
    },
    {
      title: "ประเภทสัญญา",
      dataIndex: "countType",
      key: "countType",
    },
    {
      title: "ระยะเวลาขาดการติดต่อ",
      dataIndex: "countDay",
      key: "countDay",
    },
    {
      title: "จำนวนสัญญา",
      dataIndex: "countCONTNO",
      key: "countCONTNO",
    },
    {
      title: "จำนวนสถานะสืบทรัพย์",
      dataIndex: "countItemA",
      key: "countItemA",
    },
    {
      title: "จำนวนสถานะออกบอกเลิก",
      dataIndex: "countItemB",
      key: "countItemB",
    },
  ];
export default dataColumnMain;
